// @generated
// This file is automatically generated by packages/registry/generate-class-registry.ts
// DO NOT EDIT THIS FILE MANUALLY
// Changes will be overwritten when the script runs

import type { KlearClassRegistry } from '@klear/registry/class'

import { Address } from '@klear/address'
import { BasisPoints } from '@klear/basis-points'
import { Credit } from '@klear/credit'
import { Customer } from '@klear/customer'
import { KlearDate } from '@klear/date'
import { TraderDocument } from '@klear/document/trader-document'
import { Fee } from '@klear/fee'
import { FeeAllocation } from '@klear/fee/fee-allocation'
import { Funder } from '@klear/funder'
import { InternationalExternalFinancialAccount } from '@klear/international-external-financial-account'
import { InternationalFinancialAccount } from '@klear/international-financial-account'
import { Invoice } from '@klear/invoice'
import { InvoiceOffer } from '@klear/invoice-offer'
import { InvoiceOfferFeeRate } from '@klear/invoice-offer-fee-rate'
import { KlearFinancialAccount } from '@klear/klear-financial-account'
import { KycModel } from '@klear/kyc'
import { LegalAgreement } from '@klear/legal-agreement'
import { Money } from '@klear/money'
import { Operational } from '@klear/operational'
import { Order } from '@klear/order'
import { Organization } from '@klear/organization'
import { PaasPosition } from '@klear/paas'
import { PaasOffer } from '@klear/paas/paas-offer'
import { Payable } from '@klear/payable'
import { Payment } from '@klear/payment'
import { ProofOfAcceptance } from '@klear/proof-of-acceptance'
import { PurchaseOrder } from '@klear/purchase-order'
import { Rate } from '@klear/rate'
import { Supplier } from '@klear/supplier'
import { SupplierExternalBankAccount } from '@klear/supplier-external-bank-account'
import { Timestamp } from '@klear/time'
import { Trader } from '@klear/trader'
import { TraderExternalBankAccount } from '@klear/trader-external-bank-account'
import { GeneratedLegalAgreementDocument } from '@klear/trader-legal-agreement/generated-legal-agreement-document'
import { TraderLegalAgreementAcceptance } from '@klear/trader-legal-agreement/trader-legal-agreement-acceptance'
import { User } from '@klear/user'
import { UserLegalAgreementAcceptance } from '@klear/user-legal-agreement/user-legal-agreement-acceptance'

/** Maps wire tag → constructor for tRPC deserialize */
export const CLASS_REGISTRY = {
  Address,
  BasisPoints,
  Credit,
  Customer,
  Fee,
  FeeAllocation,
  Funder,
  GeneratedLegalAgreementDocument,
  InternationalExternalFinancialAccount,
  InternationalFinancialAccount,
  Invoice,
  InvoiceOffer,
  InvoiceOfferFeeRate,
  KlearDate,
  KlearFinancialAccount,
  KycModel,
  LegalAgreement,
  Money,
  Operational,
  Order,
  Organization,
  PaasOffer,
  PaasPosition,
  Payable,
  Payment,
  ProofOfAcceptance,
  PurchaseOrder,
  Rate,
  Supplier,
  SupplierExternalBankAccount,
  Timestamp,
  Trader,
  TraderDocument,
  TraderExternalBankAccount,
  TraderLegalAgreementAcceptance,
  User,
  UserLegalAgreementAcceptance
} satisfies KlearClassRegistry
